"use client";
import { useEffect } from "react";
import { useLocale } from "next-intl";
import { isActiveLocale } from "@/i18n/config";
import { api } from "@/lib/api";

// Uygulamanın BAŞLANGIÇ dilini belirler; auth ekranlarında (login/register/consent…)
// takılıdır. next-intl dili yalnızca NEXT_LOCALE cookie'sinden okur; bu bileşen o
// cookie'yi iki kaynaktan doldurur, öncelik sırasıyla:
//
//   1. `?lang=tr|en…` — landing (ayrı subdomain) oradaki dil seçimini bu parametreyle
//      taşır. Parametre her durumda URL'den temizlenir: kullanıcı buradaki switcher'dan
//      dili değiştirince sonraki reload'da ?lang onu eski değere geri çekmesin.
//   2. Cookie hiç yoksa (bu tarayıcıdan ilk giriş) `GET /geo`: IP'nin ülkesine göre
//      başlangıç dili. Tahmin cookie'ye yazılır ki her sayfada yeniden sorulmasın;
//      kullanıcı dil seçiciden değiştirince cookie onun seçimini taşır.
//
// Cookie zaten varsa hiçbir şey yapılmaz (reload döngüsü olmaz).
function readCookie(): string | undefined {
  return document.cookie.match(/(?:^|; )NEXT_LOCALE=([^;]+)/)?.[1];
}

function writeCookie(lang: string) {
  document.cookie = `NEXT_LOCALE=${lang}; path=/; max-age=31536000; samesite=lax`;
}

export default function LocaleSync() {
  const active = useLocale();

  useEffect(() => {
    const url = new URL(window.location.href);
    const lang = url.searchParams.get("lang");
    const current = readCookie();

    if (lang && isActiveLocale(lang)) {
      url.searchParams.delete("lang");
      if (current === lang) {
        window.history.replaceState({}, "", url.toString());
        return;
      }
      writeCookie(lang);
      window.history.replaceState({}, "", url.toString());
      window.location.reload();
      return;
    }

    if (current) return;

    // Cookie yok, landing'den de gelinmedi: ülkeye göre başlangıç dili.
    let cancelled = false;
    api.geo()
      .then(({ locale }) => {
        if (cancelled || readCookie()) return; // bu arada kullanıcı seçim yaptıysa dokunma
        const next = isActiveLocale(locale) ? locale : "en";
        writeCookie(next);
        if (next !== active) window.location.reload();
      })
      .catch(() => { /* backend yoksa varsayılan (İngilizce) kalır */ });
    return () => { cancelled = true; };
  }, [active]);

  return null;
}
